import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../../Components/Navbar/navbar";
import styles from "../../../Styles/edit.module.css";
import { HiMenu, HiMinusCircle, HiPlus, HiPlusCircle, HiSearch, HiX, HiXCircle } from "react-icons/hi";
import { useLocation, useNavigate, useParams } from "react-router";
import axios from "axios";
import { getUser, Url, UrlAFACARD } from "../../../../Constants/globals";
import RefreshToken from "../../../../Components/RefreshToken/RefreshToken";
import Dropdown from "../../../../Components/Dropdown/dropdown";
import GoBack from "../../../../Components/GoBack/goback";
import stylesModal from "../../../../Components/DeleteModal/deletemodal.module.css";
import Loading from "../../../../Components/Loading/loading";
import Alert from "../../../../Components/Alert/alert";
import { ChromePicker } from 'react-color'

async function addNewInfo(companyId, type, value, customHandle) {
    if (!customHandle) return ["", <Alert type={"error"}>{`Indique o nome do campo`}</Alert>];
    if (!value) return ["", <Alert type={"error"}>{`Indique o valor do campo ${customHandle}`}</Alert>];
    try {
        const response = await axios.post(`${UrlAFACARD}/companies/${companyId}/links`,
            {
                link_type_id: type.id,
                label_override: customHandle,
                value: value
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Informação adicionada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await addNewInfo(companyId, type, value, customHandle);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação"}</Alert>];
        }
    };
}

async function deleteNewInfo(id, companyId) {
    try {
        await axios.delete(`${UrlAFACARD}/companies/${companyId}/links/${id}`, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [200, <Alert type={"success"}>Informação eliminada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await deleteNewInfo(id, companyId);
            else window.location.reload();
        }
        else {
            console.error(err);
            return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a informação"}</Alert>];
        }
    };
}

async function addCompany(nome, logo, cor1, cor2, cor3) {
    const formData = new FormData();

    const data = {
        name: nome,
        primary_color: cor1,
        secondary_color: cor2,
        text_color: cor3
    }

    formData.append("data", JSON.stringify(data));
    if (logo) formData.append("logo", logo);

    try {
        const res = await axios.post(`${UrlAFACARD}/companies`, formData, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [res.data, <Alert type={"success"}>Empresa adicionada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await addCompany(nome, logo, cor1, cor2, cor3);
            else window.location.reload();
        }
        else {
            console.error(err);
            return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a empresa"}</Alert>];
        }
    };
}

async function editCompany(id, nome, logo, cor1, cor2, cor3) {
    const formData = new FormData();

    const data = {
        name: nome,
        primary_color: cor1,
        secondary_color: cor2,
        text_color: cor3
    }

    formData.append("data", JSON.stringify(data));
    if (logo) formData.append("logo", logo);

    try {
        await axios.patch(`${UrlAFACARD}/companies/${id}`, formData, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [200, <Alert type={"success"}>Empresa editada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await editCompany(id, nome, logo, cor1, cor2, cor3);
            else window.location.reload();
        }
        else {
            console.error(err);
            return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a empresa"}</Alert>];
        }
    };
}

function EditarEmpresasCartoes({ userPermissions }) {

    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();
    const { id } = useParams();
    const newInfoRef = useRef();
    const dragItem = useRef(null);
    const dragOverItem = useRef(null);

    const [alert, setAlert] = useState("");
    const [loading, setLoading] = useState("");
    const [loadingData, setLoadingData] = useState(true);

    const [foregroundColor, setForegroundColor] = useState("#000000");
    const [backgroundColor, setBackgroundColor] = useState("#000000");
    const [textColor, setTextColor] = useState("#000000");

    const [nome, setNome] = useState("");
    const [logo, setLogo] = useState(null);

    const [dragOverIndex, setDragOverIndex] = useState(null);

    const [addInfo, setAddInfo] = useState(false);

    const [newInfoHandle, setNewInfoHandle] = useState("");
    const [newInfo, setNewInfo] = useState("");
    const [infoTypes, setInfoTypes] = useState([]);
    const [selectedInfoType, setSelectedInfoType] = useState("");

    const [info, setInfo] = useState([]);

    async function fetchDetails() {
        try {
            const res = await axios.get(`${UrlAFACARD}/companies/${id}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchDetails();
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }

    async function fetchCompanyLinks() {
        try {
            const res = await axios.get(`${UrlAFACARD}/companies/${id}/links`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchCompanyLinks();
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function fetchInfoTypes() {
        try {
            const res = await axios.get(`${UrlAFACARD}/link-types`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchInfoTypes();
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function assignData() {
        if (id) {
            const results = await Promise.all([fetchDetails(), fetchCompanyLinks(), fetchInfoTypes()]);
            const [detailsData, companyLinks, infoTypesData] = results;
            setInfo(companyLinks?.length ? companyLinks : []);
            setInfoTypes(infoTypesData?.items?.length ? infoTypesData.items : []);
            if (detailsData) {
                setNome(detailsData.name);
                if (detailsData.logo_url) setLogo(detailsData.logo_url);
                setForegroundColor(detailsData.primary_color);
                setBackgroundColor(detailsData.secondary_color);
                setTextColor(detailsData.text_color);
            }
            else navigate("/empresas-cartoes");
        }
        setLoadingData(false);
    }

    useEffect(() => {
        assignData();
    }, [id]);

    async function getAlertAdd() {
        if (!nome || !logo || !foregroundColor || !backgroundColor || !textColor) return setAlert(<Alert type={"error"}>Os campos do nome, logo e das cores são obrigatórios</Alert>);
        await setLoading(<Loading />);
        await setAlert("");
        const res = await addCompany(nome, logo, foregroundColor, backgroundColor, textColor);
        setLoading("");
        if (res[0]) window.location = `/empresas-cartoes/${res[0].id}`;
        else setAlert(res[1]);
    }

    async function getAlertEdit() {
        if (!nome || !logo || !foregroundColor || !backgroundColor || !textColor) return setAlert(<Alert type={"error"}>Os campos do nome, logo e das cores são obrigatórios</Alert>);
        await setLoading(<Loading />);
        await setAlert("");
        const res = await editCompany(id, nome, typeof logo === "string" ? "" : logo, foregroundColor, backgroundColor, textColor);
        setLoading("");
        setAlert(res[1]);
    }

    async function getAlertAddInfo() {
        await setAlert("");
        const res = await addNewInfo(id, selectedInfoType, newInfo, newInfoHandle);
        setAlert(res[1]);
        const companyLinks = await fetchCompanyLinks();
        setInfo(companyLinks?.length ? companyLinks : []);
    }

    async function getAlertDelete(infoId) {
        await setAlert("");
        const res = await deleteNewInfo(infoId, id);
        setAlert(res[1]);
        const companyLinks = await fetchCompanyLinks();
        setInfo(companyLinks?.length ? companyLinks : []);
    }

    useEffect(() => {
        setNewInfoHandle(selectedInfoType.label ? selectedInfoType.label : "");
        setNewInfo(selectedInfoType.default_value ? selectedInfoType.default_value : "");
        if (newInfoRef?.current) newInfoRef.current.focus();
    }, [selectedInfoType]);

    async function changeFieldPosition(link_id, companyId, new_position) {
        try {
            await axios.patch(`${UrlAFACARD}/companies/${companyId}/links/${link_id}/reorder`,
                { new_position }, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            const companyLinks = await fetchCompanyLinks();
            setInfo(companyLinks?.length ? companyLinks : []);
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await changeFieldPosition(link_id, companyId, new_position);
                else window.location.reload();
            }
            else {
                console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar a ordenação dos campos");
            }
        }
    }

    function handleDragStart(index) {
        dragItem.current = index;
    }

    function handleDragEnter(index) {
        dragOverItem.current = index;
        setDragOverIndex(index);
    }

    async function handleDragEnd() {
        const from = dragItem.current;
        const to = dragOverItem.current;
        setDragOverIndex(null);
        if (from === null || to === null || from === to) {
            dragItem.current = null;
            dragOverItem.current = null;
            return;
        }
        const newInfo = [...info];
        const [moved] = newInfo.splice(from, 1);
        newInfo.splice(to, 0, moved);
        setInfo(newInfo);
        dragItem.current = null;
        dragOverItem.current = null;
        await changeFieldPosition(moved.id, id, to);
    }

    return (
        <div className="body">
            {alert}
            {loading}
            <NavBar current={"empresas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
            {
                loadingData ? ""
                    :
                    <div className={styles.content}>
                        <GoBack backRoute={`/empresas-cartoes`} backState={state?.page ? { page: state.page, nomeSearch: state.nomeSearch ?? "" } : {}} />
                        <h1 className={styles.backgroundName}>
                            {
                                id ? "Editar empresa" : "Adicionar empresa"
                            }
                        </h1>
                        <div className={styles.formBlock}>
                            <div className={styles.formBlockSection}>
                                <p>
                                    Nome:
                                </p>
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                />
                            </div>
                            <div className={styles.formBlockSection}>
                                <p style={{ display: "flex", gap: "8px" }}>
                                    {
                                        logo ?
                                            <HiXCircle color="var(--buttonBackground)" style={{ cursor: "pointer" }} size={18} onClick={() => setLogo(null)} />
                                            : ""
                                    }
                                    Logo:
                                </p>
                                {
                                    logo ?
                                        <img src={typeof logo === "string" ? `${UrlAFACARD}/${logo}` : URL.createObjectURL(logo)} className={styles.companyLogo} alt="logo" />
                                        :
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => setLogo(e.target.files[0])}
                                        />
                                }
                            </div>
                            <div style={{ gridColumnStart: 1, gridColumnEnd: 4 }}>
                                <div>
                                    <div className={styles.formBlockSection} style={{ display: "flex", justifyContent: "center", gap: "60px", backgroundColor: "transparent", padding: 0 }}>
                                        <div>
                                            <p>Cor primária:</p>
                                            <ChromePicker
                                                disableAlpha
                                                color={foregroundColor}
                                                onChange={(color) => setForegroundColor(color.hex)}
                                            />
                                        </div>
                                        <div>
                                            <p>Cor secundária:</p>
                                            <ChromePicker
                                                disableAlpha
                                                color={backgroundColor}
                                                onChange={(color) => setBackgroundColor(color.hex)}
                                            />
                                        </div>
                                        <div>
                                            <p>Cor do texto:</p>
                                            <ChromePicker
                                                disableAlpha
                                                color={textColor}
                                                onChange={(color) => setTextColor(color.hex)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ gridColumnStart: 1, gridColumnEnd: 4 }}>
                                <div className={styles.formBlockSection} style={{ marginTop: "2rem", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "transparent", padding: 0 }}>
                                    <div style={{ boxShadow: "0 0 5px 3px #00000020", overflow: "hidden", borderRadius: "14px" }}>
                                        <div style={{ backgroundColor: backgroundColor }} className={styles.secondColor}>
                                            {
                                                logo ?
                                                    <img src={typeof logo === "string" ? `${UrlAFACARD}/${logo}` : URL.createObjectURL(logo)} className={styles.companyLogo2} alt="logo" />
                                                    : ""
                                            }
                                        </div>
                                        <div style={{ backgroundColor: foregroundColor }} className={styles.firstColor}>
                                            <div style={{ padding: "24px 20px 18px 20px" }}>
                                                <p style={{ margin: 0, fontSize: "12pt", color: textColor, fontWeight: "600" }}>
                                                    Nome
                                                </p>
                                                <p style={{ margin: "6px 0 0 0", fontSize: "10pt", color: textColor }}>
                                                    Cargo
                                                </p>
                                                <p style={{ margin: "3px 0 0 0", fontSize: "10pt", color: textColor }}>
                                                    Departamento
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            id ?
                                <>
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}>
                                        Informações
                                        {
                                            addInfo ?
                                                <HiMinusCircle
                                                    className={styles.icon}
                                                    onClick={() => setAddInfo(false)}
                                                />
                                                :
                                                <HiPlusCircle
                                                    className={styles.icon}
                                                    onClick={() => setAddInfo(true)}
                                                />
                                        }
                                    </h3>
                                    {
                                        addInfo ?
                                            <div className={styles.formBlock} style={{ marginBottom: "2rem" }}>
                                                <Dropdown
                                                    label={"Tipo:"}
                                                    placeholder={"Escolher tipo de informação"}
                                                    valueLabel="display_name"
                                                    items={infoTypes}
                                                    value={selectedInfoType}
                                                    onValueChange={setSelectedInfoType}
                                                />
                                                {
                                                    selectedInfoType ?
                                                        <div className={styles.formBlockSection}>
                                                            <input
                                                                style={{ backgroundColor: "var(--background)", width: "200px" }}
                                                                type="text"
                                                                placeholder="Nome do campo"
                                                                value={newInfoHandle}
                                                                onChange={(e) => setNewInfoHandle(e.target.value)}
                                                            />
                                                            <input
                                                                ref={newInfoRef}
                                                                type="text"
                                                                autoFocus={selectedInfoType}
                                                                value={newInfo}
                                                                onChange={(e) => setNewInfo(e.target.value)}
                                                            />
                                                            <button
                                                                className={styles.btnFileType}
                                                                style={{ width: "160px", marginRight: "8px", backgroundColor: "var(--hoverItem)" }}
                                                                onClick={() => getAlertAddInfo()}
                                                            >
                                                                Adicionar
                                                            </button>
                                                        </div>
                                                        :
                                                        <div></div>
                                                }
                                            </div>
                                            : ""
                                    }
                                    {
                                        info?.length ?
                                            <div style={{ marginBottom: "1rem", placeItems: "center" }} className={styles.formBlock}>
                                                {
                                                    info.map((i, index) =>
                                                        <div
                                                            key={i.id}
                                                            className={styles.formBlockSection}
                                                            draggable
                                                            onDragStart={() => handleDragStart(index)}
                                                            onDragEnter={() => handleDragEnter(index)}
                                                            onDragEnd={handleDragEnd}
                                                            onDragOver={(e) => e.preventDefault()}
                                                            style={{
                                                                width: "calc(50% - 2rem)",
                                                                gridColumnStart: 1,
                                                                gridColumnEnd: 4,
                                                                opacity: dragItem.current === index ? 0.4 : 1,
                                                                border: dragOverIndex === index && dragItem.current !== index
                                                                    ? "2px dashed var(--buttonBackground)"
                                                                    : "2px solid transparent",
                                                                transition: "border 0.15s ease, opacity 0.15s ease",
                                                                cursor: "grab"
                                                            }}
                                                        >
                                                            <HiMenu
                                                                size={18}
                                                                style={{ flexShrink: 0, color: "var(--placeholder, #aaa)", cursor: "grab" }}
                                                                title="Arrastar para reordenar"
                                                            />
                                                            <p style={{ whiteSpace: "nowrap" }}>
                                                                {i.label_override ? i.label_override : i.link_type?.display_name ? i.link_type.display_name : ""}:
                                                            </p>
                                                            <input disabled type="text" value={i.value} />
                                                            <HiX style={{ marginRight: "8px", cursor: "pointer", flexShrink: 0 }} color="red" onClick={() => getAlertDelete(i.id)} />
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            : ""
                                    }
                                </>
                                : ""
                        }
                        {
                            id ?
                                <button className={styles.btn} onClick={() => getAlertEdit()}>
                                    Editar empresa
                                </button>
                                :
                                <button className={styles.btn} onClick={() => getAlertAdd()}>
                                    Adicionar empresa
                                </button>
                        }
                    </div>
            }
        </div>
    );
}

export default EditarEmpresasCartoes;